exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-fullscreenControl-___Fullscreen__button___xTuZK {\n  pointer-events: all;\n  cursor: pointer;\n  width: 1rem;\n  height: 1rem;\n  margin: 0.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.src-components-fullscreenControl-___Fullscreen__button___xTuZK.src-components-fullscreenControl-___Fullscreen__mobile___3WHj4 {\n  width: 30px;\n}", ""]);

// exports
exports.locals = {
	"button": "src-components-fullscreenControl-___Fullscreen__button___xTuZK",
	"mobile": "src-components-fullscreenControl-___Fullscreen__mobile___3WHj4"
};